import * as Actions from './actions/actions';
import {DefaultSettings} from "../../../settings/settings-util";
import {Reducer, Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
import {AlmeUIResponseArray, Message} from "../../../types/response";
import {AlmeResponseV5} from "@alme/types/response/AlmeResponse";
import {HistoryMessage, HistoryMessageAlme, HistoryMessageUser} from "../../../types/history";


export default class GetHistoryResponseHandler
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer(): Reducer<AlmeState>
    {
        return (state: AlmeState): AlmeState => state;
    }

    doesHandle(response): boolean
    {
        return response.messageType === this._settings.messageConstants.getHistoryRequest;
    }

    process(message: Message): Message
    {
        if (!this.doesHandle(message)) { return message; }

        const responses = (message.response as AlmeUIResponseArray) ?? [];
        
        if (responses.length)
        {
            this.saveRawResponses(responses);
            this.saveStageableResponses(responses);
        }
        
        return message;
    }

    //#endregion



    //#region Response Methods

    saveRawResponses(responses: AlmeUIResponseArray): void
    {
        const stateLocation = this._settings.stateLocations.History.RawMessages;

        this._store?.dispatch(Actions.receivedHistoryResponse(responses, stateLocation));
    }

    saveStageableResponses(responses: AlmeUIResponseArray): void
    {
        const stateLocation = this._settings.stateLocations.History.Messages;
        const stageableResponses = responses.flatMap(response => this.createHistoryMessages(response));

        this._store?.dispatch(Actions.receivedHistoryResponse(stageableResponses, stateLocation));
    }

    createHistoryMessages(response: AlmeResponseV5): HistoryMessage[]
    {
        const { responseRevision, maskedInput, extensionData, text, navUrl, responseActions, displayLinkCollection } = response;
        const { userInputType, almeResponseType } = this._settings.messageConstants;

        const almeResponse: HistoryMessageAlme =
        {
            type: almeResponseType,
            responseRevision,
            text,
            navUrl,
            displayLinkCollection,
            responseActions,
            extensionData,
        };

        if ((maskedInput?.trim()?.length ?? 0) > 0)
        {
            return [{ type: userInputType, responseRevision, maskedInput, extensionData } as HistoryMessageUser, almeResponse];
        }

        return [almeResponse];
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/initialization-gethistory/src/response-handler-history.ts